import { c as _c } from "react/compiler-runtime";
import { createContext, type ReactNode, useContext } from "react";
import type { TypeProduct, TypeProductWrapper } from "@/types/contentful/generated";
export interface ResolvedProductWrapper {
  product: TypeProduct<undefined, string>["fields"];
  productWrapper: TypeProductWrapper<undefined, string>["fields"];
}
interface ProductBuilderContextValue {
  product: TypeProduct<undefined, string>["fields"];
  productWrapper: TypeProductWrapper<undefined, string>["fields"];
  resolvedWrappers: ResolvedProductWrapper[];
  parentProductTitle?: string;
  parentProductDescription?: string;
}
const ProductBuilderContext = createContext<ProductBuilderContextValue | null>(null);
interface Props extends ProductBuilderContextValue {
  children: ReactNode;
}
export function ProductBuilderProvider(t0) {
  const $ = _c(9);
  const {
    children,
    product,
    productWrapper,
    resolvedWrappers,
    parentProductTitle,
    parentProductDescription
  } = t0;
  let t1;
  if ($[0] !== parentProductDescription || $[1] !== parentProductTitle || $[2] !== product || $[3] !== productWrapper || $[4] !== resolvedWrappers) {
    t1 = {
      product,
      productWrapper,
      resolvedWrappers,
      parentProductTitle,
      parentProductDescription
    };
    $[0] = parentProductDescription;
    $[1] = parentProductTitle;
    $[2] = product;
    $[3] = productWrapper;
    $[4] = resolvedWrappers;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== t1) {
    t2 = <ProductBuilderContext.Provider value={t1}>{children}</ProductBuilderContext.Provider>;
    $[6] = children;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}
export function useProductBuilderContext() {
  const context = useContext(ProductBuilderContext);
  if (!context) {
    throw new Error("useProductBuilderContext must be used within ProductBuilderProvider");
  }
  return context;
}